<template>
    <div class="bg-white px-3 index" >
        <div class="inner_b" :style="{height:height}">
            <el-form class="form-inlines  " label-width="150px">
                <div>
                    <el-form-item label="app版本号：">
                        <el-input placeholder="请输入app版本号" style="max-width:300px" size="small" v-model="version"
                            class="heade_ipt" clearable>
                        </el-input>
                    </el-form-item>
                </div>
                <div class="sub_btns">
                    <el-form-item>
                        <el-button class="btn1" :loading='searchloading' size="small" @click="getvers" icon="el-icon-refresh-right">
                            刷新</el-button>
                        <el-button size="small" @click="submit" icon="el-icon-s-promotion" type="primary">
                            提交</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
    export default {
        components: {

        },
        data() {
            return {
                version: '',
                searchloading:false,
                height: null,
            }
        },
        mounted() {
            this.getvers()
            this. getHeight() 
        },
        methods: {
            getHeight() {
				let that = this
				that.height = window.innerHeight - 180 + 'px'
				window.onresize = () => {
					that.height = window.innerHeight - 180 + 'px'
				}
			},
            getvers() {
                this.searchloading=true
                let data = {
                    id: 24
                }
                this.axios.post('/admin/pc/sysSettingDetail', data, {
                    token: true
                }).then(res => {
                    this.version = res.data.data.value
                    this.searchloading=false
                }).catch(err => {
                    this.searchloading=false

                })
            },
            submit() {
                let that = this
                if (!this.version) return this.$message.error('请输入app版本号')
                this.$prompt(`请确认更改版本号为${this.version},请输入密码继续提交`, '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputType: 'password',
                    closeOnClickModal: false,
                    beforeClose(action, instance, done) {
                        if (action == 'confirm') {
                            if (instance.inputValue == 'zyj..') {
                                that.submitvers(done)
                            } else {
                                this.$message({
                                    type: 'info',
                                    message: '密码错误！'
                                });
                            }
                        } else {
                            done()
                        }
                    }
                }).then(({
                    value
                }) => {
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消'
                    });
                });
            },
            submitvers(d) {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.2)'
                });
                let data = {
                    id: 24,
                    name:'app_version',
                    value: this.version,
                }
                this.axios.post('/admin/sysconfig', data, {
                    token: true
                }).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            type: "success",
                            message: "修改成功"
                        })
                        d()
                    }else{
                        this.$message(res.data.msg)
                    }

                    loading.close();

                }).catch(err => {
                    loading.close();

                })

            },

        }
    }
</script>

<style lang="scss" scoped>
    .sub_btns {
        margin-top: 50px;
        display: flex;

        .btn1 {
            margin-right: 15px;
        }
    }
</style>